const features = [
  {
    icon: 'ri-vip-crown-line',
    title: '全本免费，无需付费',
    desc: '所有<strong>免费漫画全集</strong>资源完全免费开放，无隐藏收费、无会员限制、无阅读次数限制，真正做到全集免费看。',
    color: 'bg-primary-50',
    iconColor: 'text-primary-500',
  },
  {
    icon: 'ri-timer-flash-line',
    title: '每日同步更新',
    desc: '与各大漫画平台保持同步更新节奏，第一时间提供<strong>免费完整版漫画</strong>最新章节，追更不落后。',
    color: 'bg-accent-50',
    iconColor: 'text-accent-500',
  },
  {
    icon: 'ri-stack-line',
    title: '海量资源全覆盖',
    desc: '汇集全网<strong>免费漫画大全</strong>资源库，涵盖热血、恋爱、奇幻等全题材，从经典长篇到新番连载一应俱全。',
    color: 'bg-secondary-50',
    iconColor: 'text-secondary-500',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">平台优势</h2>
          <p className="text-sm text-foreground-500 max-w-[500px] mx-auto">为什么千万漫迷选择UU漫画作为<strong>在线免费阅读</strong>首选平台</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="flex flex-col items-center text-center p-6 md:p-8 rounded-xl border border-background-200/60 bg-background-50"
            >
              <div className={`w-16 h-16 md:w-20 md:h-20 rounded-2xl flex items-center justify-center mb-5 ${feature.color}`}>
                <i className={`${feature.icon} text-3xl md:text-4xl ${feature.iconColor}`}></i>
              </div>
              <h3 className="text-lg md:text-xl font-heading text-foreground-900 mb-3">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed" dangerouslySetInnerHTML={{ __html: feature.desc }}></p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}